import { useState, useEffect } from 'react';

import { VIRAL_LOOPS_LOADER_ID, VIRAL_LOOPS_SCRIPT_SRC } from './constants';

type Props = {
  campaignId: string;
  email?: string;
  firstName?: string;
  lastName?: string;
};

export const useViralLoop = ({ campaignId, email, firstName, lastName }: Props): null => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const onWidgetScriptLoaded = async (): Promise<void> => {
      const campaign = await window.ViralLoops.getCampaign(campaignId);

      if (campaign) {
        const loggedInUser = await campaign.identify({
          email,
          firstname: firstName,
          lastname: lastName,
        });

        setUser(loggedInUser);
      } else {
        console.error('Campaign not found');
      }

      window.removeEventListener('vlReady', onWidgetScriptLoaded);
      const scriptToRemove = document.getElementById(VIRAL_LOOPS_LOADER_ID);
      scriptToRemove?.remove();
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.ViralLoops = undefined;
    };

    const script = document.createElement('script');
    script.setAttribute('id', VIRAL_LOOPS_LOADER_ID);
    script.setAttribute('src', VIRAL_LOOPS_SCRIPT_SRC);
    script.setAttribute('data-campaign-id', campaignId);
    document.head.appendChild(script);

    window.addEventListener('vlReady', onWidgetScriptLoaded);

    return () => {
      window.removeEventListener('vlReady', onWidgetScriptLoaded);
    };
  }, [campaignId, email, firstName, lastName]);

  return user;
};
